module.exports = __webpack_public_path__ + "static/TALGenerative-5542452b240e08fdd2ecd9c85404777f.svg";